export default __webpack_public_path__ + "static/media/visionBg.a07da2c9.jpg";